module.exports = __webpack_public_path__ + "static/img/m6.b86dbde.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/m6.jpg
// module id = 933W
// module chunks = 1